import { TypographyProps } from "@material-ui/core/Typography";
import { ISubMenu } from "./interfaces/ISubMenu";
import { i18n } from "./translations/i18n";
import { EDirectoryPreferences } from "./features/Profile/NationalDirectoryEnquiries/interface/INDDPreference";
import { fixUrlLanguage } from "@utils/changeLanguage";

export const BRAND_NAME = "GoMo";

export const isMobileSize = window.innerWidth <= 768;

export const STORAGE = "eir-myaccount";

const HOME_PAGE_URL_EN = "/en/home";

const BILLS_PAGE_URL_EN = "/en/bills";

const USAGE_PAGE_URL_EN = "/en/usage";

const PROFILE_PAGE_URL_EN = "/en/profile";

const REGISTER_PAGE_URL_EN = "/en/register";

const PAYMENTS_PAGE_URL_EN = "/en/payments";

const FORGOTEMAIL_PAGE_URL_EN = "/en/forgot_email";

const EMAILVERIFICATION_PAGE_URL_EN = "/en/email_verification";

const ALERTS_PAGE_URL_EN = "/en/alerts";

const ACCOUNT_DETAILS_PAGE_URL_EN = "/en/account_details";

const PORTIN_PAGE_URL_EN = `${ACCOUNT_DETAILS_PAGE_URL_EN}/port_in`;

const MANAGE_SIM_URL_EN = `${ACCOUNT_DETAILS_PAGE_URL_EN}/manage_sim`;

const BARRINGS_PAGE_URL_EN = `${ACCOUNT_DETAILS_PAGE_URL_EN}/barrings`;

const CANCEL_NUMBER_PAGE_URL_EN = `${ACCOUNT_DETAILS_PAGE_URL_EN}/cancel_number`;

const ORDERS_PAGE_URL_EN = `${ACCOUNT_DETAILS_PAGE_URL_EN}/orders`;

const RESET_CREDIT_LIMIT_URL_EN = `${ACCOUNT_DETAILS_PAGE_URL_EN}/reset_credit_limit`;

const TERMINATE_NUMBER_URL_EN = `${ACCOUNT_DETAILS_PAGE_URL_EN}/terminate_number`;

const MANAGE_MOBILE_SERVICES_URL_EN = `${ACCOUNT_DETAILS_PAGE_URL_EN}/manage_mobile_services`;

const SUBMIT_DOCUMENTS_URL_EN = "/en/submitDocuments";

const TWO_WAY_AUTH_OTP_URL_EN = "/en/two_way_auth";

const HOME_PAGE_URL_EL = "/el/home";

const BILLS_PAGE_URL_EL = "/el/bills";

const USAGE_PAGE_URL_EL = "/el/usage";

const PROFILE_PAGE_URL_EL = "/el/profile";

const REGISTER_PAGE_URL_EL = "/el/register";

const PAYMENTS_PAGE_URL_EL = "/el/payments";

const FORGOTEMAIL_PAGE_URL_EL = "/el/forgot_email";

const EMAILVERIFICATION_PAGE_URL_EL = "/el/email_verification";

const ALERTS_PAGE_URL_EL = "/el/alerts";

const ACCOUNT_DETAILS_PAGE_URL_EL = "/el/account_details";

const PORTIN_PAGE_URL_EL = `${ACCOUNT_DETAILS_PAGE_URL_EL}/port_in`;

const MANAGE_SIM_URL_EL = `${ACCOUNT_DETAILS_PAGE_URL_EL}/manage_sim`;

const BARRINGS_PAGE_URL_EL = `${ACCOUNT_DETAILS_PAGE_URL_EL}/barrings`;

const CANCEL_NUMBER_PAGE_URL_EL = `${ACCOUNT_DETAILS_PAGE_URL_EL}/cancel_number`;

const ORDERS_PAGE_URL_EL = `${ACCOUNT_DETAILS_PAGE_URL_EL}/orders`;

const RESET_CREDIT_LIMIT_URL_EL = `${ACCOUNT_DETAILS_PAGE_URL_EL}/reset_credit_limit`;

const TERMINATE_NUMBER_URL_EL = `${ACCOUNT_DETAILS_PAGE_URL_EL}/terminate_number`;

const MANAGE_MOBILE_SERVICES_URL_EL = `${ACCOUNT_DETAILS_PAGE_URL_EL}/manage_mobile_services`;

const SUBMIT_DOCUMENTS_URL_EL = "/el/submitDocuments";

const TWO_WAY_AUTH_OTP_URL_EL = "/el/two_way_auth";

export const { WORDPRESS_URL } = process.env;

export const WORDPRESS_FAQ_URL = `${WORDPRESS_URL}/when-you-leave`;

export const HELP_SUPPORT_URL = `${WORDPRESS_URL}/help-support/`;
export const { ESHOP_URL } = process.env;

const CART_PAGE_URL_EN = "/en/cart";
const CART_PAGE_URL_EL = "/el/cart";
const DETAILS_PAGE_URL_EN = "/en/customerDetails";
const DETAILS_PAGE_URL_EL = "/el/customerDetails";
const SUMMARY_PAGE_URL_EN = "/en/summary";
const SUMMARY_PAGE_URL_EL = "/el/summary";
const CONFIRMATION_PAGE_URL_EN = "/en/confirmation";
const CONFIRMATION_PAGE_URL_EL = "/el/confirmation";
const MYACCOUNT_URL_EN = "/en/myaccount";
const MYACCOUNT_URL_EL = "/el/myaccount";
const ESHOP_URL_EN = "/en/home";
const ESHOP_URL_EL = "/el/home";
const WORDPRESS_HOME_URL_EN = "/en/home";
const WORDPRESS_HOME_URL_EL = "/el/home";
const WORDPRESS_ABOUT_URL_EN = "/en/about-gomo";
const WORDPRESS_ABOUT_URL_EL = "/el/about-gomo";
const WORDPRESS_HELP_URL_EN = "/el/help-support";
const WORDPRESS_HELP_URL_EL = "/el/help-support";
const WORDPRESS_PRICING_URL_EN = "/en/pricing";
const WORDPRESS_PRICING_URL_EL = "/el/pricing";
const WORDPRESS_TERM_URL_EN = "/en/terms";
const WORDPRESS_TERM_URL_EL = "/el/terms";
const WORDPRESS_LEGAL_URL_EN = "/en/legal";
const WORDPRESS_LEGAL_URL_EL = "/el/legal";
const WORDPRESS_PRIVACY_URL_EN = "/en/privacy";
const WORDPRESS_PRIVACY_URL_EL = "/el/privacy";
const WORDPRESS_COOKIES_URL_EN = "/en/cookies";
const WORDPRESS_COOKIES_URL_EL = "/el/cookies";
const WORDPRESS_GETTING_STARTED_URL_EN = "/en/joining-getting-started-with-gomo";
const WORDPRESS_GETTING_STARTED_URL_EL = "/el/joining-getting-started-with-gomo";
const WORDPRESS_ROAMING_URL_EN = "/en/our-roaming-rates";
const WORDPRESS_ROAMING_URL_EL = "/el/our-roaming-rates";

export const URLS = {
    ACCOUNT_DETAILS_PAGE_URL_EN,
    ALERTS_PAGE_URL_EN,
    BARRINGS_PAGE_URL_EN,
    BILLS_PAGE_URL_EN,
    USAGE_PAGE_URL_EN,
    CANCEL_NUMBER_PAGE_URL_EN,
    EMAILVERIFICATION_PAGE_URL_EN,
    FORGOTEMAIL_PAGE_URL_EN,
    HOME_PAGE_URL_EN,
    MANAGE_SIM_URL_EN,
    ORDERS_PAGE_URL_EN,
    PAYMENTS_PAGE_URL_EN,
    PORTIN_PAGE_URL_EN,
    PROFILE_PAGE_URL_EN,
    REGISTER_PAGE_URL_EN,
    RESET_CREDIT_LIMIT_URL_EN,
    TERMINATE_NUMBER_URL_EN,
    MANAGE_MOBILE_SERVICES_URL_EN,
    SUBMIT_DOCUMENTS_URL_EN,
    TWO_WAY_AUTH_OTP_URL_EN,
    ACCOUNT_DETAILS_PAGE_URL_EL,
    ALERTS_PAGE_URL_EL,
    BARRINGS_PAGE_URL_EL,
    BILLS_PAGE_URL_EL,
    USAGE_PAGE_URL_EL,
    CANCEL_NUMBER_PAGE_URL_EL,
    EMAILVERIFICATION_PAGE_URL_EL,
    FORGOTEMAIL_PAGE_URL_EL,
    HOME_PAGE_URL_EL,
    MANAGE_SIM_URL_EL,
    ORDERS_PAGE_URL_EL,
    PAYMENTS_PAGE_URL_EL,
    PORTIN_PAGE_URL_EL,
    PROFILE_PAGE_URL_EL,
    REGISTER_PAGE_URL_EL,
    RESET_CREDIT_LIMIT_URL_EL,
    TERMINATE_NUMBER_URL_EL,
    MANAGE_MOBILE_SERVICES_URL_EL,
    SUBMIT_DOCUMENTS_URL_EL,
    TWO_WAY_AUTH_OTP_URL_EL,
};

/* API CONSTANTS */

export enum EORDER_STATUS {
    ERROR = "ERROR",
    PENDING = "PENDING",
    IN_PROGRESS = "IN PROGRESS",
    SKIPPED = "SKIPPED",
    PARTIAL = "PARTIAL",
    COMPLETED = "COMPLETED",
    RECEIVED = "RECEIVED",
    PURGED = "PURGED",
    RUNNING = "RUNNING",
    CANCELED = "CANCELED",
}

export enum EORDER_TYPE {
    CROSS_SELL = "New Order",
    ACQUISITION = "New Order",
    CHANGE_SIMCARD = "Change Of Sim Card",
}

export enum EPAYMENT_TYPES_NAME {
    CREDIT_CARD = "creditDebitCard",
}

export enum EPAYMENT_TYPES {
    CREDIT_CARD = "CREDIT_CARD",
}

export enum EADDRESS_TYPES {
    BILLING = "BILLING",
    DELIVERY = "DELIVERY",
}

export enum ENUMBER_TYPES {
    FAX = "FAX",
    FIXE = "FIXE",
    MOBILE = "MOBILE",
}

export enum EPAYMENT_INITIALISE_TYPES {
    RESET_CREDIT_LIMIT = "RESET_CREDIT_LIMIT",
    MY_BALANCE_PAYMENT = "MY_BALANCE_PAYMENT",
    ADD_CARD = "ADD_CARD",
}

/* USER UTILS */
export const ACTIVE_CUSTOMER = "ACTIVE_CUSTOMER";

export const NO_LONGER_CUSTOMER = "NO_LONGER_CUSTOMER";

export const NationalDirectoryEnquiriesList = [
    {
        label: i18n.t("Listed"),
        name: EDirectoryPreferences.LISTED,
        value: false,
    },
    {
        label: i18n.t("Unlisted"),
        name: EDirectoryPreferences.UNLISTED,
        value: false,
    },
];

export const AccountDetailsMenuList = [
    {
        isBlockedIfNoService: true,
        title: i18n.t("sim:replaceActivateSim"),
        url: MANAGE_SIM_URL_EN,
        preventIfInCollection: true,
    },
    {
        externalUrl: process.env.ESHOP_URL + fixUrlLanguage(ESHOP_URL_EN) ?? "",
        isBlockedIfNoService: false,
        title: i18n.t("accountDetails:buyNewSIM"),
        preventIfInCollection: true,
    },
    {
        isBlockedIfNoService: true,
        title: i18n.t("barrings:barMobileServices"),
        url: BARRINGS_PAGE_URL_EN,
        preventIfInCollection: false,
    },
    {
        isBlockedIfNoService: false,
        title: i18n.t("order:myOrders"),
        url: ORDERS_PAGE_URL_EN,
        preventIfInCollection: false,
    },
    {
        isBlockedIfNoService: true,
        title: i18n.t("accountDetails:resetCreditCardLimit"),
        url: RESET_CREDIT_LIMIT_URL_EN,
        preventIfInCollection: true,
    },
    {
        isBlockedIfNoService: true,
        title: i18n.t("accountDetails:terminateMyNumber"),
        url: TERMINATE_NUMBER_URL_EN,
        preventIfInCollection: false,
    },
    {
        isBlockedIfNoService: true,
        title: i18n.t("accountDetails:manageMobileServices"),
        url: MANAGE_MOBILE_SERVICES_URL_EN,
        preventIfInCollection: true,
    },
];

export const NoServiceAccountDetailsMenuList = [
    {
        externalUrl: process.env.ESHOP_URL + fixUrlLanguage(ESHOP_URL_EN) ?? "",
        isBlockedIfNoService: false,
        title: i18n.t("accountDetails:buyNewSIM"),
        preventIfInCollection: true,
    },
    {
        isBlockedIfNoService: false,
        title: i18n.t("order:myOrders"),
        url: ORDERS_PAGE_URL_EN,
        preventIfInCollection: false,
    },
];

export const SubMenuList: ISubMenu[] = [
    {
        label: `${i18n.t("navigation:myHome")}`,
        url: HOME_PAGE_URL_EN,
    },
    {
        label: i18n.t("navigation:myAlerts"),
        url: ALERTS_PAGE_URL_EN,
    },
    {
        label: i18n.t("navigation:myBills"),
        url: BILLS_PAGE_URL_EN,
    },
    {
        label: i18n.t("navigation:myUsage"),
        url: USAGE_PAGE_URL_EN,
    },
    {
        label: i18n.t("navigation:myPayments"),
        url: PAYMENTS_PAGE_URL_EN,
    },
    {
        label: i18n.t("navigation:accountDetails"),
        url: ACCOUNT_DETAILS_PAGE_URL_EN,
    },
    {
        label: i18n.t("navigation:myProfile"),
        url: PROFILE_PAGE_URL_EN,
    },
    {
        label: i18n.t("navigation:submitDocuments"),
        url: SUBMIT_DOCUMENTS_URL_EN,
    },
];
// </editor-fold>

export const DATE_FORMAT = "dd/MM/yyyy";

export const API_DATE_FORMAT = "yyyy-MM-dd";

export const TIME_FORMAT = "HH:mm";

export const TIME_FORMAT_SECONDS = "HH:mm:ss";

// Subscription
export const MOBILE_DOMAIN = "MOBILE";

// Order
export const COMPLETED_ORDER_STATUS = "COMPLETED";

// Port in
export const PORT_IN_STATUS_NOT_FOUND = "COULDNT_FIND_PORT";

// Sim Status
export const INITIAL_SIM_ONGOING = "INITIAL_SIM_ONGOING_ERROR";

export const PENDING_ORDER = "A_REPLACEMENT_ORDER_ALREADY_EXISTS";

export const OFFER_CONFIG = {
    BRAND: "GOMO",
    CHANNEL: "MYACCOUNT",
    CHANNEL_TYPE: "DIRECT",
};

export const PAYMENT_TYPE = [
    { value: "BILL_PAY_SINGLE_LINE", label: "Postpay single line" },
    { value: "BILL_PAY_MULTI_LINE", label: "Postpay multi line" },
    { value: "PAYG_REGISTERED", label: "Prepay registered" },
    { value: "PAYG_UNREGISTERED", label: "Prepay unregistered" },
];

// <editor-fold desc="TITLE STYLE" defaultstate="collapsed">
export const TITLE_INHERIT_STYLE: Partial<TypographyProps> = { variant: "h2", color: "inherit", align: "center" };

export const TITLE_PRIMARY_STYLE: Partial<TypographyProps> = { variant: "h2", color: "primary", align: "center" };
// </editor-fold>

// <editor-fold desc="IFRAME ID" defaultstate="collapsed">
export const IFRAME_ID_ADD_PAYMENT_CARD = "addPaymentCardIframe";

export const IFRAME_ID_PAYMENT = "paymentIframe";
// </editor-fold>

export const MONTH_LIST = [
    { label: i18n.t("month:january"), value: 1 },
    { label: i18n.t("month:february"), value: 2 },
    { label: i18n.t("month:march"), value: 3 },
    { label: i18n.t("month:april"), value: 4 },
    { label: i18n.t("month:may"), value: 5 },
    { label: i18n.t("month:june"), value: 6 },
    { label: i18n.t("month:july"), value: 7 },
    { label: i18n.t("month:august"), value: 8 },
    { label: i18n.t("month:september"), value: 9 },
    { label: i18n.t("month:october"), value: 10 },
    { label: i18n.t("month:november"), value: 11 },
    { label: i18n.t("month:december"), value: 12 },
];

export const USAGE_SERVICE_TYPE = "POSTPAY";

export const RECORDS_PER_PAGE = [10, 20, 50, 100];

export const MERGE_PATCH_HEADER = {
    "Content-Type": "application/merge-patch+json",
};

export const JSON_HEADER = {
    accept: "application/json",
};

export const ROUTES = {
    CART_PAGE_URL_EN,
    CART_PAGE_URL_EL,
    CONFIRMATION_PAGE_URL_EN,
    CONFIRMATION_PAGE_URL_EL,
    DETAILS_PAGE_URL_EN,
    DETAILS_PAGE_URL_EL,
    HOME_PAGE_URL_EN,
    HOME_PAGE_URL_EL,
    SUMMARY_PAGE_URL_EN,
    SUMMARY_PAGE_URL_EL,
    MYACCOUNT_URL_EN,
    MYACCOUNT_URL_EL,
    ESHOP_URL_EN,
    ESHOP_URL_EL,
    WORDPRESS_HOME_URL_EN,
    WORDPRESS_HOME_URL_EL,
    WORDPRESS_ABOUT_URL_EN,
    WORDPRESS_ABOUT_URL_EL,
    WORDPRESS_HELP_URL_EN,
    WORDPRESS_HELP_URL_EL,
    WORDPRESS_PRICING_URL_EN,
    WORDPRESS_PRICING_URL_EL,
    WORDPRESS_TERM_URL_EN,
    WORDPRESS_TERM_URL_EL,
    WORDPRESS_LEGAL_URL_EN,
    WORDPRESS_LEGAL_URL_EL,
    WORDPRESS_PRIVACY_URL_EN,
    WORDPRESS_PRIVACY_URL_EL,
    WORDPRESS_COOKIES_URL_EN,
    WORDPRESS_COOKIES_URL_EL,
    WORDPRESS_GETTING_STARTED_URL_EN,
    WORDPRESS_GETTING_STARTED_URL_EL,
    WORDPRESS_ROAMING_URL_EN,
    WORDPRESS_ROAMING_URL_EL,
};

export const BUILDING_TYPES = [
    "HOUSE",
    "BLOCK_OF_FLATS",
    // "SHOP",
    // "MAISONETTE",
    // "OFFICE",
    // "STUDIO",
    // "VILLA",
    // "WAREHOUSE",
    // "FACTORY",
    // "AIRPORT",
    // "PORT",
    // "PARK",
    // "HOTEL",
];
